import React, { useCallback, useEffect, useState } from 'react';
import { useFormik } from 'formik';
import Select from 'react-select';
import debounce from 'lodash.debounce';
import { Button, Card, CardBody, Col, Form, FormGroup, Input, Label, Modal, Row } from "reactstrap";
import { campaignValidationSchema } from '../../../../constants/Schemas';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import InputField from '../../../../components/InputField';
import { Actions } from '../../../../redux/actions';
import { dispatch } from '../../../../utils/store';
import { API_REQUEST, multiSelectDropdownStyle } from '../../../../constants/General';
import { TEMPLATES_API } from '../../../../constants/Configs';
import { templatesListDTO } from '../../utils/dtos/templates';
import { removeEmptyKeysFromObject, trimObjectValues, uploadImage } from '../../../../services/middleware';
import { handleError, handleSuccess } from '../../../../utils/toast';
import { CAMPAIGN_FILE_TYPE, ImageLinks, ImageType, selectDropdownStyle } from '../../../../constants/General';
import { useSelector } from 'react-redux';
import { getCustomers } from '../../utils/middleware/marketings';
import { deleteTicket, getEvent, getEventTickets } from '../../utils/middleware/events'
import TemplateModal from './../TemplateModal';
import "./campaign.css"
import moment from 'moment-timezone';
import API from "../../../../services/api"
import { GET_AICONTENT } from "../../../../constants/Configs"
import MobileViewCampaign from '../MobileViewCampaign';

const getThirdWord = (text) => {
  const words = text.trim().split(/\s+/);
  return words.length >= 3 ? words[2] : null;
};

const replaceThirdWordWithPlaceholder = (text) => {
  const words = text.trim().split(/\s+/);
  if (words.length >= 3) {
    words[2] = '{{1}}';
    return words.join(' ');
  }
  return text;
};

export default function CampaignModal(props) {
  // Props

  const { open, campaign, handleCloseModal, handleSuccess, setShowTemplateAddModal } = props

  // Store
  const { tags, customers } = useSelector(state => state.restaurantAdminMarketings)
  const { tickets, search, activeSort, sortOrder, totalCount, page } = useSelector(state => state.restaurantAdminTickets)
  const { eventList } = useSelector(state => state.restaurantAdminEvents)
  const [buttonText, setButtonText] = useState('Generate campaign content through AI');
  const { pageSize } = useSelector(state => state.user)
  //State
  const [templates, setTemplates] = useState([])
  const [selectedOption, setSelectedOption] = useState(null)
  const [isRSVPChecked, setIsRSVPChecked] = useState(false);

  // Mount
  useEffect(() => {
    getEvent({ search, sortBy: activeSort, orderBy: sortOrder, page, isRsvp: true })
    let pageCount = Math.ceil(totalCount / pageSize)
    if (totalCount && page > pageCount) {
      dispatch(Actions.RestaurantAdminReservations.SetPage, pageCount)
    }
  }, [search, activeSort, sortOrder, totalCount, page, pageSize])

  // Use useCallback to memoize the debounced function
  const debouncedGetCustomers = useCallback(
    debounce((inputValue) => {
      if (inputValue) {
        getCustomers(inputValue);
      }
    }, 500), // Adjust the debounce delay as needed
    []
  );

  const handleInputChange = (inputValue) => {
    debouncedGetCustomers(inputValue);
  };
  const handleRSVPChange = (e) => {
    setIsRSVPChecked(e.target.checked);
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    if (checked) {
      formik.setFieldValue('occuranceDay', [...formik.values.occuranceDay, name]);
    } else {
      let days = formik.values.occuranceDay;
      if (typeof formik.values.occuranceDay === 'string') {
        days = days.split(',')
      }
      formik.setFieldValue('occuranceDay', days.filter(day => day !== name));
    }
  };

  function sanitizeString(str) {
    return str.replace(/['"]/g, "");
  }

  function sanitizeSpace(input) {
  return input
    .replace(/[\n\r\t]/g, ' ')     // Replace newline (\n, \r) and tab (\t) with space
    .replace(/\s+/g, ' ')          // Replace multiple whitespace characters with single space
    .trim();                       // Remove leading/trailing spaces
}

  const handleChange = (selected) => {
    if (selected !== null) {
      let text = `generate message using event ${selected?.eventTitle} which is conduct on ${selected?.eventDate} and ${selected?.eventSummery} with character limit of 1024`;
      handleAIContentCall(text);
    }
    setSelectedOption(selected);
  };

  const handleAIContentCall = (bodyText) => {
    const payload = {
      content: `${buttonText === 'Generate campaign content through AI'
        ? bodyText
        : 'Re-Generate below content ' + bodyText}
            Please format the output as a WhatsApp Business message:
          - Use short, clear paragraphs.
          - Insert a newline (\\n) after each paragraph.
          - No HTML tags.
          - If any links are included, show full URLs (https://example.com).
          - Keep tone professional and friendly.`
    };

    dispatch(Actions.RestaurantAdmin.SetLoading, true);

    API(API_REQUEST.post, GET_AICONTENT, payload)
      .then(res => {
        if (res.status === 200) {
          if (res.data.code === 200) {
            const cleanText = res.data.data;      // Unescape any double backslash newlines

            formik.setFieldValue("message", cleanText);
            setButtonText('Re-Generate campaign content through AI');
          } else {
            handleError('Something went wrong.');
          }
        } else {
          handleError('Something went wrong.');
        }
        dispatch(Actions.RestaurantAdmin.SetLoading, false);
      })
      .catch(err => {
        handleError(err);
        dispatch(Actions.RestaurantAdmin.SetLoading, false);
      });
  };

  const getTemplates = (fileType = 'text') => {
    dispatch(Actions.RestaurantAdmin.SetLoading, true)
    const params = {
      page: 1, 'size': 1000, isApproved: true
    }
    if (!fileType) fileType = 'text';
    params.templateType = fileType && fileType.includes('image') ? "image" : fileType.includes("pdf") ? "pdf" : fileType.includes("video") ? "video" : "text";

    // if(isRSVPChecked){
    //   params.templateType = 'rsvp'
    // }
    formik.setFieldValue("draftTemplateId", null)

    API(API_REQUEST.get, TEMPLATES_API, { params })
      .then(res => {
        const rowData = templatesListDTO(res?.data?.data?.rows)
        const templates = rowData?.map(template => ({ value: template.id, label: template.name }))
        setTemplates(templates)
        dispatch(Actions.RestaurantAdmin.SetLoading, false)
      })
      .catch(err => {
        handleError(err)
        dispatch(Actions.RestaurantAdmin.SetLoading, false)
      })
  }

  useEffect(() => {
    if (campaign) {
      getTemplates(campaign?.mediaType)
    } else {
      getTemplates('text')
    }
  }, [])

  //week days selection
  const weekDaysList = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  const convertToUTC = (timeStr, flag) => {
    const timeFormat = "HH:mm";
    const localTzStr = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let utcTime;
    if (flag) {
      const localTime = moment.tz(timeStr, timeFormat, 'UTC');
      utcTime = localTime.clone().tz(localTzStr);
    } else {
      const localTime = moment.tz(timeStr, timeFormat, localTzStr);
      utcTime = localTime.clone().tz('UTC');
    }
    return utcTime.format(timeFormat);
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: campaign?.name || '',
      message: campaign?.message || '',
      allCustomers: campaign?.customers?.length === customers?.length && campaign?.customers?.every(campaignCustomer =>
        customers.some(customer => customer.id === campaignCustomer.id)
      ),
      customers: !!campaign?.customers?.length ? campaign?.customers.map(customer => ({ label: customer?.name || '', value: customer?.id || '' })) : [],
      tags: !!campaign?.tags?.length ? campaign?.tags.map(tag => ({ label: tag?.tagName || '', value: tag?.id || '' })) : [],
      media: campaign?.media || '',
      occuranceStartDate: campaign?.occuranceStartDate && campaign?.occuranceStartDate !== "0000-00-00" ? campaign?.occurance === 'repeat' ? campaign?.occuranceStartDate : '' : '',
      occuranceEndDate: campaign?.occuranceEndDate && campaign?.occuranceEndDate !== "0000-00-00" ? campaign?.occurance === 'repeat' ? campaign?.occuranceEndDate : '' : '',
      occuranceDay: typeof campaign?.occuranceDay === 'string' ? campaign?.occuranceDay.split(',') : [],
      occuranceDate: campaign?.occuranceDate && campaign?.occuranceDate !== "0000-00-00" ? campaign?.occurance === 'donotrepeat' ? campaign?.occuranceDate : '' : '',
      occuranceTime: campaign?.occuranceTime ? convertToUTC(campaign?.occuranceTime, true) : '',
      isScheduled: campaign?.isScheduled || false,
      occurance: campaign?.occurance || '',
      draftTemplateId: campaign?.draftTemplateId != null ? templates.find(template => template.value == campaign?.draftTemplateId) : null,
    },
    validationSchema: campaignValidationSchema,

    onSubmit: async (values) => {
      trimObjectValues(values, 'media')
      // values.message = values.message ? sanitizeSpace(values.message) : '';
      values.message = values.message;
      const filterData = removeEmptyKeysFromObject(values)
      if (filterData.media && !(typeof filterData.media === 'string' && ImageLinks.includes(filterData.media?.split(":")[0]))) {
        dispatch(Actions.RestaurantAdmin.SetLoading, true)
        const fileType = filterData?.media?.type?.split('/')[0];
        const logoResponse = await uploadImage(filterData.media, fileType === 'pdf' ? ImageType.CAMPAIGN_PDF : fileType === 'video' ? ImageType.CAMPAIGN_VIDEO : ImageType.CAMPAIGN_IMAGE).catch(err => {
          dispatch(Actions.RestaurantAdmin.SetLoading, false)
          handleError(err)
        })
        filterData.media = logoResponse.fileLink;
        filterData.mediaType = fileType === 'image' ? 'image' : fileType === 'video' ? 'video' : 'pdf';
      } else if (filterData.media && typeof filterData.media === 'string' && ImageLinks.includes(filterData.media?.split(":")[0])) {
        const filename = filterData.media.substring(filterData.media.lastIndexOf('/') + 1); // Get filename from URL
        const extension = filename.split('.').pop().toLowerCase(); // Get extension
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];
        const videoExtensions = ['mp4', 'mov', 'avi', 'mkv'];
        filterData.mediaType = imageExtensions.includes(extension) ? 'image' : videoExtensions.includes(extension) ? 'video' : 'pdf';
      }
      filterData.tags = filterData?.tags?.length ? filterData.tags.map(tag => tag.value) : []
      filterData.customers = filterData?.customers?.length ? filterData.customers.map(customer => customer.value) : []
      if (!!formik.values.allCustomers) {
        filterData.customers = customers
        delete filterData.allCustomers
        await getCustomers().then(res => {
          filterData.customers = res?.length ? res.map(customer => customer.value) : []
        })
      }
      if (values.isScheduled && formik.values.occurance === 'donotrepeat') {
        filterData.occuranceStartDate = '';
        filterData.occuranceEndDate = '';
        filterData.occuranceDay = [];
        delete filterData.occuranceDay;
      } else {
        filterData.occuranceDate = "";
      }
      // if(isRSVPChecked){
      //   filterData.mediaType = 'rsvp';
      // }
      // filterData.isRsvp = isRSVPChecked ? false : false;
      filterData.occuranceTime = convertToUTC(values.occuranceTime);
      filterData.occuranceDay = weekDaysList.filter(day => values.occuranceDay.includes(day));
      filterData.draftTemplateId = values.draftTemplateId ? values.draftTemplateId.value : null;
      filterData.isScheduled = values.isScheduled;
      
      const thirdWord = getThirdWord(values.message);
      if (thirdWord) {
        filterData.message = replaceThirdWordWithPlaceholder(values.message);
      }
      
      handleSuccess(filterData);
    }
  });
  return (
    <Modal
      className="modal-dialog-centered edit-modal"
      isOpen={open}
      toggle={handleCloseModal}
      size='lg'
    >
      <div className="modal-header">
        <h3 className="modal-title" id="exampleModalLabel">
          Campaign
        </h3>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={handleCloseModal}
        >
          <span aria-hidden={true}><FontAwesomeIcon icon={faXmark} size="sm" /></span>
        </button>
      </div>
      <div className="modal-body p-0 edit-template-body" >
        <Card className="border-0 edit-card">
          <CardBody>
            <Form role="form">
              <Row>
                <Col md={6}>
                  <InputField required placeholder="Name" fieldName="name" formik={formik} />
                </Col>
                <Col md={6}>
                  <InputField placeholder="Media" fieldName="media" inputType="file" action={getTemplates} accept={CAMPAIGN_FILE_TYPE} formik={formik} />
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <Label for="exampleSelect" className='inputfield'>
                    Tags
                  </Label>
                  <section className="mb-3 input-group-alternative">
                    <Select isMulti className="custom-select" options={tags} value={formik.values?.tags} isSearchable={false} styles={selectDropdownStyle}
                      onChange={selectedOption => {
                        formik.setFieldValue("tags", selectedOption);
                      }}
                    />
                    {formik.errors.tags && <span className="error-message input-group-alternative">{formik.errors.tags}</span>}
                  </section>
                </Col>
                <Col md={2} className='flex-center all-customers-checkbox'>
                  <FormGroup check inline className="custom-checkbox">
                    <Input type="checkbox" name='allCustomers' checked={formik.values.allCustomers} onChange={formik.handleChange} />
                  </FormGroup>
                  <Label className="inputfield mb-0">All Customers</Label>
                </Col>
                <Col md={6}>
                  <Label className='inputfield'>
                    Customers
                  </Label>
                  <section className="mb-3 input-group-alternative">
                    <Select isMulti isDisabled={formik.values.allCustomers} value={formik.values.customers} onInputChange={handleInputChange} styles={selectDropdownStyle}
                      onChange={selectedOption => formik.setFieldValue("customers", selectedOption)}
                      options={customers} className="custom-select" />
                    {!!formik.errors?.customers?.length && Array.isArray(formik.errors?.customers) ? <span className="error-message input-group-alternative">{formik.errors.customers.map((customer, index) => (`customer ${index + 1} ${customer?.value}`)).join(",")}</span>
                      : formik.errors.customers && <span className="error-message input-group-alternative">{formik.errors.customers}</span>}
                  </section>
                </Col>
              </Row>
              <Row>
                <Col md={2} className='d-flex align-items-center my-4'>
                  <FormGroup check inline className="custom-checkbox">
                    <Input
                      type="checkbox"
                      name="allCustomers"
                      checked={isRSVPChecked}
                      onChange={handleRSVPChange}
                    />
                  </FormGroup>
                  <Label className="inputfield mb-0">RSVP</Label>
                </Col>

                {isRSVPChecked && (
                  <Col md={4}>
                    <Label for="exampleSelect" className="inputfield">
                      Events
                    </Label>
                    <section className="mb-3 input-group-alternative">
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        placeholder="Select an Event..."
                        value={selectedOption}
                        onChange={handleChange}
                        isClearable
                        isSearchable
                        name="eventName"
                        options={eventList}
                      />
                    </section>
                  </Col>
                )}
              </Row>
              <Row>
                <Col md={6} className='d-flex align-items-center my-4'>
                  <FormGroup check inline className="custom-checkbox">
                    <Input type="checkbox" name='isScheduled' checked={formik.values.isScheduled} onChange={formik.handleChange} />
                  </FormGroup>
                  <Label className="inputfield mb-0">Scheduled</Label>
                </Col>
                {formik.values.isScheduled && (
                  <Col md={6}>
                    <Label className="inputfield mb-0">Occurance<span className="required-field"></span></Label>
                    <div className="d-flex aling-items-center justify-content-evenly">
                      <FormGroup check className='mr-4'>
                        <Input
                          name="occurance"
                          type="radio"
                          value="donotrepeat"
                          checked={formik.values.occurance === 'donotrepeat'}
                          onChange={formik.handleChange}
                        />
                        {' '}
                        <Label check>
                          Do Not Repeat
                        </Label>
                      </FormGroup>
                      <FormGroup check>
                        <Input
                          name="occurance"
                          type="radio"
                          value="repeat"
                          checked={formik.values.occurance === 'repeat'}
                          onChange={formik.handleChange}
                        />
                        {' '}
                        <Label check>
                          Repeat
                        </Label>
                      </FormGroup>
                    </div>
                  </Col>
                )}
              </Row>
              {formik.values.isScheduled && formik.values.occurance === 'repeat' && (
                <Row>
                  <Col>
                    <Label className='inputfield'>
                      Occurance Days<span className="required-field"></span>
                    </Label>
                    <div className='d-flex flex-wrap justify-content-between my-4'>
                      {weekDaysList.map(day => (
                        <div key={day} className="d-flex align-items-center justify-content-center ml-2">
                          <FormGroup check inline className="custom-checkbox pl-2">
                            <Input type="checkbox" name={day} checked={formik.values.occuranceDay.includes(day)} onChange={handleCheckboxChange} />
                          </FormGroup>
                          <Label className="inputfield mb-0">{day}</Label>
                        </div>
                      ))}
                    </div>
                  </Col>
                </Row>
              )}
              {formik.values.isScheduled && formik.values.occurance === 'donotrepeat' && (
                <Row>
                  <Col md={5}>
                    <InputField placeholder="Scheduled Date" required fieldName="occuranceDate" inputType="date" formik={formik} />
                  </Col>
                  <Col md={2}>
                    <InputField placeholder="Time" required fieldName="occuranceTime" inputType="time" formik={formik} />
                  </Col>
                </Row>
              )}
              {formik.values.isScheduled && formik.values.occurance === 'repeat' && (
                <Row>
                  <Col md={5}>
                    <InputField placeholder="From" required fieldName="occuranceStartDate" inputType="date" formik={formik} />
                  </Col>
                  <Col md={5}>
                    <InputField placeholder="TO" required fieldName="occuranceEndDate" inputType="date" formik={formik} />
                  </Col>
                  <Col md={2}>
                    <InputField placeholder="Time" required fieldName="occuranceTime" inputType="time" formik={formik} />
                  </Col>
                </Row>
              )}
              {formik.values.isScheduled && (
                <Row>
                  <Col >
                    <Label className='inputfield'>
                      Template<span className="required-field"></span>
                    </Label>
                    <section className="mb-3 input-group-alternative">
                      <Select className="custom-select" value={formik.values.draftTemplateId} options={templates} isSearchable={false} styles={multiSelectDropdownStyle}
                        onChange={selectedOption => {
                          formik.setFieldValue("draftTemplateId", selectedOption);
                        }}
                      />
                    </section>
                  </Col>
                </Row>
              )}
              <Row>
                <Col>
                  <InputField
                    placeholder="Message"
                    fieldName="message"
                    inputType="textarea"
                    rows={5}
                    formik={formik}
                    showCharactorCount
                    maxLimit={1024}
                  />
                </Col>
              </Row>
              <div className="modal-footer p-0 m-0" style={{ right: "10px", bottom: "10px" }}>
                <Button
                  color="outline-primary"
                  data-dismiss="modal"
                  type="button"
                  style={{ padding: "5px", fontSize: "11px" }}
                  onClick={() => handleAIContentCall(formik.values.message)}
                >
                  Click here to add content
                </Button>
                {/* <Button
                    color="outline-primary"
                    data-dismiss="modal"
                    type="button"
                    style={{padding: "5px", fontSize: "11px"}}
                    onClick={() => handleAIContentCall('re generate below content ' + formik.values.message)}
                  >
                    Re-Generate campaign content through AI
                  </Button> */}
              </div>
            </Form>
          </CardBody>
        </Card>
        <div className="edit-view">
          <MobileViewCampaign template={formik.values} formik={formik} />
        </div>
      </div>
      <div className="modal-footer pt-2">
        <Button
          color='outline-primary'
          data-dismiss="modal"
          type="button"
          onClick={handleCloseModal}>
          Cancel
        </Button>
        <Button color='primary' type="button" disabled={!!Object.values(formik.errors)?.length} onClick={formik.handleSubmit}>
          Submit
        </Button>
      </div>
    </Modal>
  )
}

